import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router keeps the scroll position between route changes; this resets it
 * so each page starts at the top. Must be rendered inside a <Router>.
 * Scrolls the window plus the app's scrollable containers, since some pages
 * scroll inside a nested <main> or the .app-scroll-region div rather than the
 * window.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.querySelector('.app-scroll-region')?.scrollTo(0, 0);
    document.querySelectorAll('main').forEach((el) => el.scrollTo?.(0, 0));
  }, [pathname]);

  return null;
};
